/* eslint-disable */
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

/*import url and gateway methods */
import { postData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

const ProjectDisablePopup = ({
  selectedProjectIds = [],
  showDeleteOffcanvas = false,
  onPopupClose = () => {},
  setAlertMessage = () => {},
  setMessageType = () => {},
  setShowAlert = () => {},
  reloadProjectList = () => {},
}) => {
  const token = localStorage.getItem("token");
  const { t } = useTranslation(); // for translations

  const [isLoading, setIsLoading] = useState(false);
  const [projectList, setProjectList] = useState([]);

  const [reason, setReason] = useState("");
  const [isDeleteing, setIsDeleteing] = useState(false);

  //fetch project details on selected project ids
  const fetchProjectList = async () => {
    try {
      setIsLoading(true);
      const apiData = {
        projectids: selectedProjectIds,
      };

      const requestUrl =
        url.API_BASE_URL +
        url.API_GET_PROJECT_DISABILITY_ELIGIBILITY +
        `?token=${token}`;

      const response = await postData(requestUrl, apiData);

      console.log("Project Disable Eligibility Response:", response);

      if (response.status) {
        setProjectList(response.data);
      }
    } catch (error) {
      console.error("Error fetching project list:", error.message);
    } finally {
      setIsLoading(false);
    }
  };

  //delete selected projects
  const deleteProjectHandler = async () => {
    setIsDeleteing(true);
    try {
      const projectListToBeDelete = projectList
        .filter((item) => item.disablestatus === "1")
        .map((item) => item.projectid);

      let projectData = {
        projectlist: projectListToBeDelete,
      };

      let requestURL =
        url.API_BASE_URL + url.API_DELETE_BULK_PROJECT + `?token=${token}`;

      const response = await putData(requestURL, projectData);

      console.log(response);

      if (response.status) {
        setMessageType("success");
        closeOffcanvas();
        setTimeout(() => {
          reloadProjectList();
        }, 1500);
      } else {
        setMessageType("error");
      }

      setAlertMessage(response.message);
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
    }

    setShowAlert(true);
  };

  // Clear selected user IDs when closing the offcanvas
  const closeOffcanvas = () => {
    onPopupClose();
    setReason("");
  };

  useEffect(() => {
    if (selectedProjectIds.length > 0 && showDeleteOffcanvas) {
      fetchProjectList();
    }
  }, [selectedProjectIds, showDeleteOffcanvas]);

  return (
    <div
      className="offcanvas lg offcanvas-end bg-white border-0 shadow-lg"
      tabIndex="-1"
      id="offcanvasProjectDisable"
      aria-labelledby="offcanvasProjectDisableLabel"
      style={{ display: "flex", flexDirection: "column", height: "100vh" }}
    >
      <div
        className="offcanvas-header bg-primary text-white p-4 pe-5 pb-3 border-bottom border-gray-300"
        style={{ zIndex: 2 }}
      >
        <div className="d-flex align-items-center gap-3">
          <div className="icon-wrapper p-3 bg-white rounded-circle d-flex align-items-center justify-content-center">
            <span className="material-symbols-outlined text-primary fs-5 icon-md">
              delete
            </span>
          </div>
          <div>
            <h3
              className="offcanvas-title fw-bold text-white mb-0"
              id="offcanvasProjectDisableLabel"
            >
              {t("Disable Projects")}
            </h3>
            <p className="text-white fs-sm mb-0">
              {t("Selected project disable eligibility & status")}
            </p>
          </div>
        </div>
        <button
          type="button"
          className="btn-close p-1 bg-gray-200 rounded-circle shadow-sm border-0"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          onClick={closeOffcanvas}
        ></button>
      </div>
      <div
        className="offcanvas-body p-4"
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          minHeight: 0,
        }}
      >
        {isLoading ? (
          <div className="d-flex justify-content-center align-items-center py-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : (
          <>
            {/* Table Header */}
            <div
              className="bg-primary text-white rounded-top overflow-hidden shadow-sm mb-0"
              style={{ position: "sticky", top: 0, zIndex: 1 }}
            >
              <div className="row g-0 fw-semibold py-3 px-2">
                {/* ...existing code for header columns... */}
                <div className="col-4 px-2">
                  <div className="d-flex align-items-center gap-2">
                    <span
                      className="material-symbols-outlined"
                      style={{ fontSize: "18px" }}
                    >
                      work
                    </span>
                    <span>{t("Project Title")}</span>
                  </div>
                </div>
                <div className="col-2 px-2 text-center">
                  <div className="d-flex align-items-center justify-content-center gap-1">
                    <span
                      className="material-symbols-outlined"
                      style={{ fontSize: "18px" }}
                    >
                      view_agenda
                    </span>
                    <span>{t("Section Count")}</span>
                  </div>
                </div>
                <div className="col-2 px-2 text-center">
                  <div className="d-flex align-items-center justify-content-center gap-1">
                    <span
                      className="material-symbols-outlined"
                      style={{ fontSize: "18px" }}
                    >
                      assignment
                    </span>
                    <span>{t("Task Count")}</span>
                  </div>
                </div>
                <div className="col-4 px-2 text-center">
                  <div className="d-flex align-items-center justify-content-center gap-1">
                    <span
                      className="material-symbols-outlined"
                      style={{ fontSize: "18px" }}
                    >
                      list_alt
                    </span>
                    <span>{t("Log Count")}</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Table Body - scrollable */}
            <div
              style={{
                flex: 1,
                overflowY: "auto",
                minHeight: 0,
                maxHeight: "40vh",
                background: "white",
              }}
            >
              <ul className="list-unstyled mb-4 bg-white rounded-bottom shadow-sm overflow-hidden">
                {projectList.map((project, index) => (
                  <li
                    key={index}
                    className={`border-bottom ${index === projectList.length - 1 ? "border-0" : ""}`}
                    style={{
                      transition: "background-color 0.2s ease",
                      cursor: "pointer",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.backgroundColor = "#f8f9fa")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.backgroundColor = "white")
                    }
                  >
                    <div className="row g-0 align-items-center py-3 px-2">
                      <div className="col-4 px-2">
                        <span className="fw-semibold text-truncate">
                          {project.projecttitle}
                        </span>
                      </div>
                      <div className="col-2 px-2 text-center">
                        <span className="badge bg-primary px-3 py-2 rounded-pill fw-semibold">
                          {project.sectioncount}
                        </span>
                      </div>
                      <div className="col-2 px-2 text-center">
                        <span className="badge bg-primary px-3 py-2 rounded-pill fw-semibold">
                          {project.taskcount}
                        </span>
                      </div>
                      <div className="col-4 px-2 text-center">
                        <span className="badge bg-primary px-3 py-2 rounded-pill fw-semibold">
                          {project.logcount}
                        </span>
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </>
        )}
      </div>
      <div
        className="offcanvas-footer p-4 bg-white border-top border-gray-300 rounded-bottom shadow-sm"
        style={{ position: "sticky", bottom: 0, zIndex: 10 }}
      >
        {" "}
        <div className="mb-3">
          <label
            htmlFor="reason"
            className="form-label fw-bold d-flex align-items-center gap-2"
          >
            <span className="material-symbols-outlined text-primary">
              edit_note
            </span>
            Reason (optional)
          </label>
          <textarea
            className="form-control shadow-sm"
            id="reason"
            rows={3}
            placeholder="Enter reason for disabling user..."
            style={{ border: "2px solid #dee2e6", borderRadius: "8px" }}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
          ></textarea>
        </div>
        <div className="d-flex justify-content-end gap-2 pt-3 mt-auto">
          <button
            type="button"
            className="btn btn-primary px-4 d-flex align-items-center gap-2 shadow"
            onClick={deleteProjectHandler}
            disabled={isDeleteing}
            style={{
              cursor: isDeleteing ? "not-allowed" : "pointer",
            }}
          >
            {isDeleteing ? (
              <span
                className="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
            ) : (
              <span
                className="material-symbols-outlined"
                style={{ fontSize: "18px" }}
              >
                check
              </span>
            )}
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProjectDisablePopup;
